export default `
  :root {
      /* # Font */
      --wuk-font-family: 'Montserrat';
  }
`;
